/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import {
  API_INFO_ENVIRONMENT_DEV,
  API_INFO_ENVIRONMENT_PROD,
  API_INFO_ENVIRONMENT_STAGE,
} from './ApiInfo.entity.constant';

/**
 * The dxp tenant, and its properties.
 */
export type EntityApiInfo = io.TypeOf<typeof ApiInfo>;

/**
 * The dxp tenant, and its properties.
 * @export
 */
export const ApiInfo = io.type(
  {
    environment: io.union([
      io.literal(API_INFO_ENVIRONMENT_DEV),
      io.literal(API_INFO_ENVIRONMENT_STAGE),
      io.literal(API_INFO_ENVIRONMENT_PROD),
    ]),
    version: io.string,
  },
  `ApiInfo`,
);
